// ─── État vide réutilisable (Core) ────────────────────────────────
// `texte` : ce qui manque. `aide` : quoi faire pour que ça n'y manque plus.
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function EmptyState({ icon = '📭', texte, aide, children }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={s.vide}>
      <Text style={s.emoji}>{icon}</Text>
      {!!texte && <Text style={s.videTxt}>{texte}</Text>}
      {!!aide && <Text style={s.videAide}>{aide}</Text>}
      {children}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  vide:     { alignItems: 'center', paddingVertical: 50, paddingHorizontal: 24, gap: 8 },
  emoji:    { fontSize: 34 },
  videTxt:  { fontSize: 14, color: UI.faint, textAlign: 'center' },
  videAide: { fontSize: 12, color: UI.faint, textAlign: 'center', lineHeight: 18, opacity: 0.85 },
});
